import '../../dashboard/dashboard-reset.css';

interface LabsDownloadReportProps {
  onDownload: () => void;
}

export const LabsDownloadReport = ({ onDownload }: LabsDownloadReportProps) => {
  return (
    <div className="dashboard-reset w-full self-start rounded-[10px] bg-gray-100 p-8">
      {/* Title */}
      <h3 className="mb-4 text-center text-[22px] font-bold leading-[1.3] tracking-[0] text-gray-900">
        Download Your Labs
      </h3>

      {/* Description */}
      <p className="mb-6 text-center text-base font-normal leading-relaxed text-gray-700">
        Get a complete record of your lab results and biomarker insights. Download your report to share with your
        doctor or keep for your own records.
      </p>

      {/* Download Button */}
      <button
        onClick={onDownload}
        className="flex h-10 w-full items-center justify-center rounded-full bg-catch-avocado-400 px-6 text-sm font-bold text-catch-dark-blue-90 transition-all hover:scale-105 hover:shadow-lg"
      >
        Download Report
      </button>
    </div>
  );
};
